import Layout from "@/components/layout/Layout";
import Seo from "@/components/seo/Seo";
import { organizationJsonLd, websiteJsonLd } from "@/config/seo";
import HeroSection from "@/components/home/HeroSection";
import ChamamentoSection from "@/components/home/ChamamentoSection";
import PositioningSection from "@/components/home/PositioningSection";
import HibridoGamesRankingCard from "@/components/home/HibridoGamesRankingCard";
import HomeNewsShortcut from "@/components/home/HomeNewsShortcut";
import RankingSection from "@/components/home/RankingSection";
import UpcomingEvents from "@/components/home/UpcomingEvents";
import CTAFinalSection from "@/components/home/CTAFinalSection";

export default function Index() {
  return (
    <Layout>
      <Seo
        title="FPF3 — Federação Paraibana de Funcional Fitness"
        rawTitle
        description="A autoridade do Functional Fitness na Paraíba. Rankings oficiais, eventos, boxes afiliados e filiação de atletas pela FPF3."
        canonicalPath="/"
        keywords="FPF3, Funcional Fitness, Functional Fitness, Paraíba, João Pessoa, Campina Grande, ranking, Híbrido Games, Copa F3PB, CBFF, federação esportiva"
        jsonLd={[organizationJsonLd(), websiteJsonLd()]}
      />
      <HeroSection />
      <ChamamentoSection />
      <PositioningSection />
      <section className="py-8 md:py-12">
        <div className="container mx-auto px-4">
          <HibridoGamesRankingCard />
        </div>
      </section>
      <HomeNewsShortcut />
      <RankingSection />
      <UpcomingEvents />
      <CTAFinalSection />
    </Layout>
  );
}
